import { IconWithText } from 'common/icon/icon-with-text.js';
import { CompassDirection } from 'types/compass-direction.js';
import {
  MarkerTypeGeneral,
  MarkerTypeMountain,
  MarkerTypeWaterActivity,
} from 'types/markerTypes/location-markers-type.js';
import { ILocationSummary } from 'types/markerTypesV1/marker-v1-view-type.js';
import { predicateNumber } from 'utilities/isType.js';
import { MarkerComponentType } from './utils.js';

export type WindItem = {
  key: MarkerComponentType.WindDisplay;
  index: string;
  direction?: CompassDirection;
  averageSpeed: number;
};

export const hasWind = (props: ILocationSummary): WindItem | undefined => {
  const { label, type } = props;
  if (
    props.type === MarkerTypeWaterActivity.Boating ||
    props.type === MarkerTypeGeneral.Coastal ||
    props.type === MarkerTypeMountain.Mountain ||
    props.type === MarkerTypeWaterActivity.Surfing
  ) {
    const wind = props.value.wind;
    if (wind) {
      const { averageSpeed, direction } = wind;

      if (predicateNumber(averageSpeed)) {
        return {
          key: MarkerComponentType.WindDisplay,
          index: `${type}-${label}`,
          direction,
          averageSpeed,
        };
      }
    }
  }

  return undefined;
};

export const Wind = ({ direction, averageSpeed }: WindItem) => (
  <IconWithText
    icon="wind"
    classes="IconWithText--vCenter IconWithText--small IconWithText--inline u-mL-xs"
    contentClass="u-textRegular"
    iconClass="svg-fill-textSlate"
  >
    {direction} {averageSpeed}kt
  </IconWithText>
);
